import { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import { motion, AnimatePresence } from "framer-motion";
import { Menu, X } from "lucide-react";
import { LOGO } from "../data/site";
import { BOOKING_URL } from "./ui-kit";

const LINKS = [
  { to: "/", label: "Home" },
  { to: "/about", label: "About" },
  { to: "/what-is-hyrox", label: "Hyrox" },
  { to: "/programs", label: "Programs" },
  { to: "/schedule", label: "Schedule" },
  { to: "/pricing", label: "Pricing" },
  { to: "/success-stories", label: "Stories" },
  { to: "/events", label: "Events" },
  { to: "/contact", label: "Contact" },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);
  const loc = useLocation();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 30);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  useEffect(() => { setOpen(false); window.scrollTo(0, 0); }, [loc.pathname]);

  return (
    <header
      className={`fixed top-0 inset-x-0 z-50 transition-all duration-300 ${scrolled ? "bg-black/70 backdrop-blur-xl border-b border-white/10 py-3" : "bg-transparent py-5"}`}
      data-testid="navbar"
    >
      <nav className="max-w-7xl mx-auto px-6 md:px-12 flex items-center justify-between">
        <Link to="/" className="flex items-center group" data-testid="logo">
          <img src={LOGO.wordmarkWhite} alt="Hybrid Fitness Collective" className="h-8 md:h-9 w-auto object-contain" />
        </Link>

        <div className="hidden lg:flex items-center gap-6">
          {LINKS.map((l) => (
            <Link
              key={l.to}
              to={l.to}
              data-testid={`nav-${l.label.toLowerCase()}`}
              className={`text-sm font-medium uppercase tracking-wide transition-colors whitespace-nowrap ${loc.pathname === l.to ? "text-gold" : "text-lightgrey hover:text-white"}`}
            >
              {l.label}
            </Link>
          ))}
        </div>

        <div className="flex items-center gap-3">
          <a
            href={BOOKING_URL}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="nav-book"
            className="hidden sm:inline-flex rounded-full bg-gold text-black text-sm font-bold px-5 py-2.5 hover:bg-white transition"
          >
            Free Intro
          </a>
          <button className="lg:hidden text-white" onClick={() => setOpen(!open)} data-testid="menu-toggle">
            {open ? <X /> : <Menu />}
          </button>
        </div>
      </nav>

      <AnimatePresence>
        {open && (
          <motion.div
            initial={{ height: 0, opacity: 0 }} animate={{ height: "auto", opacity: 1 }} exit={{ height: 0, opacity: 0 }}
            className="lg:hidden overflow-hidden bg-black/95 backdrop-blur-xl border-t border-white/10"
          >
            <div className="px-6 py-6 flex flex-col gap-4">
              {LINKS.map((l) => (
                <Link key={l.to} to={l.to} className={`text-lg uppercase font-display ${loc.pathname === l.to ? "text-gold" : "text-white"}`}>{l.label}</Link>
              ))}
              <a href={BOOKING_URL} target="_blank" rel="noopener noreferrer" className="mt-2 rounded-full bg-gold text-black font-bold py-3 text-center">Free Intro</a>
            </div>
          </motion.div>
        )}
      </AnimatePresence>
    </header>
  );
}
